import { render, staticRenderFns } from "./AdmissionConfirmCertificate.vue?vue&type=template&id=51b42419&"
import script from "./AdmissionConfirmCertificate.vue?vue&type=script&lang=js&"
export * from "./AdmissionConfirmCertificate.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionConfirmCertificate.vue?vue&type=style&index=0&id=51b42419&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports